import React from 'react';
import styled from 'styled-components';

import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import OrbitGlyphText from '../glyphIcons';
import { TOrbit } from '../i18n/TModules';
import { orbitTokens, orbitType } from '../styles';

const Row = styled.div`
  display: flex;
  justify-content: center;
`;

// div.sysNote `4952:7116`. The 37.5px horizontal padding is deliberate and large: the pill hugs a
// centred string rather than filling the column.
// TODO(AF-11): 8.8 measured, taken to the nearest clean step (figma-spec-v2.md § 4b). Unanchored.
const Pill = styled.p`
  margin: 0;
  padding: 5px 37.5px;
  background: ${orbitTokens.surface};
  border: 1px solid ${orbitTokens.bubbleBorder};
  border-radius: 20px;
  color: ${orbitTokens.threadFaint};
  ${orbitType.helping}
  font-weight: 400;
  text-align: center;
`;

/** Explains that typing a question started the investigation on its own. Drawn once per session. */
const OrbitSysNote: React.FC = () => {
  const { t } = useMultiLanguageTranslation();

  return (
    <Row>
      <Pill data-testid="orbit-sys-note">
        <OrbitGlyphText text={t(`${TOrbit}.thread.sysNote`)} />
      </Pill>
    </Row>
  );
};

export default OrbitSysNote;
